<template>
  <dynamic-scroller-item
    :active="active"
    :item="item"
    :size-dependencies="sizeDependencies"
  >
    <div
      class="sf-virtual-table-row__container"
      :data-testid="testId"
      :style="rowStyle"
    >
      <div
        v-if="withSelector"
        class="
          tw-flex
          tw-justify-end
          tw-border-0
          tw-border-b
          tw-border-solid
          tw-border-gray-100
        "
      >
        <sf-checkbox v-model="writableSelect"></sf-checkbox>
      </div>
      <slot />
    </div>
  </dynamic-scroller-item>
</template>

<script>
import { DynamicScrollerItem } from 'vue-virtual-scroller'
import SfCheckbox from '@app/shared/vue/components/sf-checkbox'

export default {
  components: {
    DynamicScrollerItem,
    SfCheckbox,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
    minCellWidth: {
      type: Number,
      default: 0,
    },
    rowSize: {
      type: Number,
      required: true,
    },
    sizeDependencies: {
      type: Array,
      required: false,
      default: () => [],
    },
    withSelector: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selectRow'],
  data() {
    return {
      isSelected: this.selected,
    }
  },

  computed: {
    testId() {
      return this.active
        ? 'sf-virtual-table-row'
        : 'sf-virtual-table-row-inactive'
    },
    rowStyle() {
      const selector = this.withSelector ? '25px' : ''
      return {
        'grid-template-columns': `${selector} repeat(${this.rowSize}, minmax(${
          this.minCellWidth + 'px'
        }, 1fr)`,
      }
    },
    writableSelect: {
      get() {
        return this.selected
      },
      set(newValue) {
        this.isSelected = newValue

        // Because of Vue's reactivity model and the way sf-checkbox is built, we can just access newValue directly here
        this.$emit('selectRow', newValue)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'silverfin-ui-kit/src/scss/tooling';

.sf-virtual-table-row__container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding-bottom: 2px;
}
</style>
